import React from "react";
import "./RangilpurBranch.css";

function RangilpurBranch() {
  return (
    <div className="rangilpur-branch-containers">
      {/* Header Section */}
      <header className="branch-header">
        <h1>Rangilpur Branch</h1>
        <p>
          Welcome to the Rangilpur Branch. We are committed to providing quality
          education, strong moral values, and modern facilities for our students.
        </p>
      </header>

      {/* Campus Info Section */}
      <section className="branch-info">
        <h2>About Our Branch</h2>
        <p>
          The Rangilpur Branch features well-structured classrooms, science and
          computer laboratories, a library, and spacious grounds for sports and
          extracurricular activities. Our focus is to deliver high academic
          standards and character development.
        </p>
      </section>

      {/* Facilities Section */}
      <section className="branch-facilities">
        <h2>Facilities</h2>
        <ul>
          <li>Modern Classrooms</li>
          <li>Science & Computer Labs</li>
          <li>Library</li>
          <li>Sports Ground</li>
          <li>Transport Service</li>
        </ul>
      </section>

      {/* Contact Details */}
      <section className="branch-contact">
        <h2>Contact Information</h2>
        <p>
          <strong>Address:</strong> Rangilpur, Multan, Pakistan
        </p>
        <p>
          <strong>Phone:</strong> +92 321 6309158
        </p>
        <p>
          <strong>Email:</strong> academicgroupofschools@gmail.com
        </p>
      </section>

      {/* Google Map Embed */}
      <section className="branch-map">
        <h2>Find Us on Map</h2>
        <div className="map-container">
          <iframe
            title="Rangilpur Branch Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13622.764444016956!2d71.4536969!3d30.1530436!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x393b320ac5b04f6f%3A0xabcdef123456789!2s30%C2%B009'11.0%22N%2071%C2%B027'22.6%22E!5e0!3m2!1sen!2s!4v1694936502045!5m2!1sen!2s"
            width="100%"
            height="350"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
        <a
          href="https://www.google.com/maps/place/30%C2%B009'11.0%22N+71%C2%B027'22.6%22E/@30.1530436,71.4536969,17z"
          target="_blank"
          rel="noopener noreferrer"
          className="directions-btn"
        >
          📍 Get Directions
        </a>
      </section>
    </div>
  );
}

export default RangilpurBranch;
